export default __webpack_public_path__ + "static/media/focus.2b72e1d9.png";